import i18n from "../i18n";
import * as Yup from "yup";

export const createPCInOutPermitSchema = (isAttachments: {
  haveEmployeeId: number;
}) => {
  return Yup.object({
    employeeName: Yup.string().required(
      i18n.language === "en"
        ? "Employee name is required."
        : "اسم الموظف مطلوب."
    ),
    uploadEmployeeIDCard: Yup.mixed().when([], {
      is: () => isAttachments.haveEmployeeId,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema
          .required(
            i18n.language === "en"
              ? "Employee ID card is required."
              : "بطاقة هوية الموظف مطلوبة."
          ),
    }),

    deviceType: Yup.string().required(
      i18n.language === "en" ? "Device type is required." : "نوع الجهاز مطلوب."
    ),
    serialNumber: Yup.string().required(
      i18n.language === "en"
        ? "Serial number is required."
        : "الرقم التسلسلي مطلوب."
    ),

    building: Yup.string().required(
      i18n.language === "en" ? "Building is required." : "المبنى مطلوب."
    ),

    permitStartDate: Yup.string().required(
      i18n.language === "en"
        ? "Permit start date is required."
        : "تاريخ بدء التصريح مطلوب."
    ),
    permitEndDate: Yup.string().required(
      i18n.language === "en"
        ? "Permit end date is required."
        : "تاريخ انتهاء التصريح مطلوب."
    ),
  });
};
